/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".structure[_ngcontent-%COMP%]{width:100%}.structure-content[_ngcontent-%COMP%]{padding:0 15px;background-color:#fbfbfb}@media (min-width:992px){.structure[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:stretch;height:100vh}.structure-nav[_ngcontent-%COMP%]{order:0;flex:0 1 250px;align-self:auto}.structure-content[_ngcontent-%COMP%]{order:0;flex:1 1 auto;align-self:auto}}@media (min-width:1200px){.structure-nav[_ngcontent-%COMP%]{flex:0 1 375px}}"];
export { styles as styles };
